import { render, staticRenderFns } from "./DocumentPappersIcon.vue?vue&type=template&id=71b764e0"
import script from "./DocumentPappersIcon.vue?vue&type=script&lang=js"
export * from "./DocumentPappersIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports